import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NumberField from "../../../Components/NumberField";
import { CircularProgress } from "@mui/material";
import Button from "../../../Components/Button";
import axios from "axios";
import { baseUrl } from "../../../utilities/configurations";

const MaxicareCardOldNumber = () => {
  const {
    formatOldMobileNumber,
    isLoading,cardNumber,
    setOldMobileErrorMsg,
    setOldMobileNumber,
    oldMobileErrorMsg,
    oldMobileNumber,
    setIsLoading,
    middleName,
    suffixName,
    firstName,
    birthDate,
    navigate,
    lastName,
  } = useRecoveryAccountContext();

  const handleBack = () => {
    navigate(-1);
  };

  const handleVerifyOldNumber = async () => {
    if (
      oldMobileNumber !== "" &&
      oldMobileNumber.startsWith(9) &&
      oldMobileNumber.length === 10
    ) {
      try {
        setIsLoading(true);
        const ip = await axios.get("https://api.ipify.org/?format=json");
        const city = await axios.get(
          `https://ipapi.co/${JSON.stringify(ip.data.ip).replaceAll(
            '"',
            ""
          )}/json/`
        );
        const response = await axios.post(
          baseUrl + `/account-recovery/verify-old-mobile`,
          {
            recoveryType: "CardNumber",
            recoveryValue: cardNumber.replace(/\s/g, ""),
            phoneNo: oldMobileNumber,
            ipAddress: JSON.stringify(ip.data.ip).replaceAll('"', ""),
            location: JSON.stringify(city.data.city).replaceAll('"', ""),
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            suffixName: suffixName,
            birthDate: birthDate,
          },
          { withCredentials: true }
        );
        if (response.data.status) {
          setOldMobileNumber("");
          setIsLoading(false);
          navigate("/recovery-account/maxicare-card-number/new-number", { replace: true });
        }
        if (response.data.status === false) {
          setOldMobileErrorMsg(
            "Oops! Mobile number doesn't match with your credentials."
          );
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    } else {
      setOldMobileErrorMsg(
        "Oops! That doesn't look like a valid mobile number. Please check and enter a valid one"
      );
    }
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Enter your old phone number
            </div>
            <div className="flex flex-row mt-1">
              <div className=" text-[#60656D]">
                Please provide the mobile number associated with your account to
                initiate recovery and verify your identity
              </div>
            </div>

            <div className="font-bold mt-3">Mobile number</div>

            <div className="mt-1">
              <NumberField
                id="mobileNumber"
                type="text"
                adornment="+63"
                value={oldMobileNumber}
                onChange={formatOldMobileNumber}
                onKeyUp={(e) => {
                  if (
                    e.key === "Enter" &&
                    oldMobileNumber.length === 10 &&
                    isLoading === false
                  ) {
                    handleVerifyOldNumber();
                  }
                }}
                error={oldMobileErrorMsg !== ""}
                helperText={oldMobileErrorMsg || ""}
              />
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            disabled={oldMobileNumber.length < 10 || isLoading}
            className={`w-full h-12 mt-2 ${
              oldMobileNumber.length < 10 || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleVerifyOldNumber}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaxicareCardOldNumber;
